// tooltip.component.ts
import { Component, HostListener, Input, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipService } from './tooltip.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnDestroy {
  @Input() tooltipId!: string;
  isVisible = false;
  private subscription: Subscription;

  constructor(private tooltipService: TooltipService) {
    this.subscription = this.tooltipService.activeTooltipId$.subscribe(id => {
      this.isVisible = id === this.tooltipId;
    });
  }

  toggleTooltip(event: Event): void {
    event.stopPropagation();
    if (this.isVisible) {
      this.tooltipService.closeTooltips();
    } else {
      this.tooltipService.openTooltip(this.tooltipId);
    }
  }

  @HostListener('document:click')
  closeTooltip(): void {
    this.tooltipService.closeTooltips();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
